import React, { useLayoutEffect, useState } from 'react'
import 'react-big-calendar/lib/css/react-big-calendar.css'
import 'react-datepicker/dist/react-datepicker.css'
import Grid from '@mui/material/Grid'
import Box from '@mui/material/Box'
import Typography from '@mui/material/Typography'
import { EtaCalendar } from '../../components/EtaCalendar/EtaCalendar'
import classNames from 'classnames'
import { flexcol, flexItemCenter, flexItemLeft } from '../../global'
import { useStyles } from './style'
import { appTheme } from '../../theme'
import { useNavigate } from 'react-router-dom'
import {
  Button,
  IconButton,
  useMediaQuery
} from '@mui/material'
import AddIcon from '@mui/icons-material/Add'
import { Views } from 'react-big-calendar'
import CalendarIcon from '../../images/calendarIcon.svg'
import NewEventIcon from '../../images/NewEventIcon.svg'
import { getEventQueue } from '../../services/EventService'
import moment from 'moment'
import { EventStatus, Role } from '../../services/Types'
import { ApprovalStatus } from '../../services/Types'
import { CalendarDialogs } from './CalendarDialogs'
import { CalendarAccordions } from './CalendarAccordions'
import { CalendarLegend } from './CalendarLegend'
import { CalendarEventSlider } from './CalendarEventSlider'

var isMobView = false

export interface CalendarEventQueueInterface {
  id: number
  title: string
  status: string
  summary: string
  eventType: string
  seriesId: number
  createrId: number
  levelOneApproverEmail: string
  roomBooking: {
    date: string
    startTime: number
    endTime: number
    category: string
  }
  dryRun: {
    startTime: number
    date: string
    category: string
    dateFormatted: string
    timeFormatted: string
  }
  ownEvent: boolean
  approvalStatus: string
  date: string
  time: string
}

export default function EtaCalendarPage() {
  isMobView = useMediaQuery(appTheme.breakpoints.down('md'))
  const classes = useStyles()
  const buttonlabel = 'Request A New Event'
  const navigate = useNavigate()
  const userData = localStorage.getItem('user') || '{}'
  const user = JSON.parse(userData)
  const role = user.role

  var approverLevel = -1
  if (role === 'APPROVER') {
    approverLevel = user.approverLevel
  }

  const navigateRequestingTypePage = () => {
    let user: any = localStorage.getItem('user')
    if (user === 'null' || user === null) {
      handleOpen()
      return
    }
    navigate('/event/requestingType')
  }

  const eventQueueAdminLabels = (eventStatus: string) => {
    if (eventStatus === EventStatus.SAVED) return 'Draft'
    if (eventStatus === EventStatus.APPROVED) return 'Approved & Booked'
    if (eventStatus === EventStatus.APPROVAL1) return 'Pending - Program Office'
    return `Pending - Level ${eventStatus.replace('APPROVAL', '')}`
  }

  const eventQueueRequesterLabels = (eventStatus: string) => {
    if (eventStatus === EventStatus.SAVED) return 'Draft'
    if (eventStatus === EventStatus.APPROVED) return 'Approved & Booked'
    return 'Pending Approval'
  }

  // CheckBox
  const allStatus = [
    'SAVED',
    'APPROVAL1',
    'APPROVAL2',
    'APPROVAL3',
    'APPROVED',
    'ETA',
    'DRY',
    'BLOCKED'
  ]
  const [selectedStatus, selectStatus] = useState<string[]>([])

  useState(() => {
    // if (role === undefined) selectStatus(['ETA', 'BLOCKED'])
    if (role === undefined) selectStatus(['BLOCKED'])
    else if (role === 'ADMIN')
      selectStatus([
        'SAVED',
        'APPROVAL1',
        'APPROVAL2',
        'APPROVAL3',
        'APPROVED',
        'DRY',
        'BLOCKED'
      ])
    else if (approverLevel === 1) selectStatus(['APPROVAL1'])
    else if (approverLevel === 2) selectStatus(['APPROVAL2'])
    else if (approverLevel === 3) selectStatus(['APPROVAL3'])
    else selectStatus(allStatus)
  })

  const handleCheckboxChange = (event: {
    target: { name: string; checked: any }
  }) => {
    const name = event.target.name
    if (name === 'APPROVAL_PENDING') {
      selectStatus(selectedStatus =>
        selectedStatus.includes('APPROVAL1')
          ? selectedStatus.filter(f => f !== 'APPROVAL1')
          : [...selectedStatus, 'APPROVAL1']
      )

      selectStatus(selectedStatus =>
        selectedStatus.includes('APPROVAL2')
          ? selectedStatus.filter(f => f !== 'APPROVAL2')
          : [...selectedStatus, 'APPROVAL2']
      )

      selectStatus(selectedStatus =>
        selectedStatus.includes('APPROVAL3')
          ? selectedStatus.filter(f => f !== 'APPROVAL3')
          : [...selectedStatus, 'APPROVAL3']
      )
    } else {
      selectStatus(selectedStatus =>
        selectedStatus.includes(name)
          ? selectedStatus.filter(f => f !== name)
          : [...selectedStatus, name]
      )
    }
  }

  // Dialog Box
  const [openModal, setOpenModal] = React.useState(false)
  const handleOpen = () => setOpenModal(true)

  const [eventQueue, setEventQueue] = useState<CalendarEventQueueInterface[]>([])

  // event card
  const eventsTitle: any = eventQueue.map((obj: any) => obj.title)
  eventsTitle.length > 0 && eventsTitle.push('View$$All%%Events')
  const [activeState, setActiveState] = useState<string>(eventsTitle[0])

  //All Events
  const [openAllEvents, setOpenAllEvents] = useState(false)

  const formatEventQueue = (events: any) => {
    events.sort((a: any, b: any) =>
      a.roomBooking?.date === b.roomBooking?.date
        ? a.roomBooking?.startTime - b.roomBooking?.startTime
        : a.roomBooking?.date - b.roomBooking?.date
    )

    if (user.approverLevel === 1) {
      events = [
        ...events
          .filter(
            (x: any) =>
              x.createrId !== user.id ||
              (x.status === EventStatus.APPROVAL1 &&
                x.levelOneApproverEmail === user.email)
          )
          .map((x: any) => ({ ...x, ownEvent: false })),
        ...events
          .filter(
            (x: any) =>
              x.createrId === user.id &&
              !(
                x.status === EventStatus.APPROVAL1 &&
                x.levelOneApproverEmail === user.email
              )
          )
          .map((x: any) => ({ ...x, ownEvent: true }))
      ]
    } else if (user.approverLevel > 1) {
      events = [
        ...events
          .filter((x: any) => x.createrId !== user.id)
          .map((x: any) => ({ ...x, ownEvent: false })),
        ...events
          .filter((x: any) => x.createrId === user.id)
          .map((x: any) => ({ ...x, ownEvent: true }))
      ]
    }

    events = events.map((event: any) => {
      const liveData = event.roomBooking
      let approvalStatus = event.eventType
      if (user?.role === Role.REQUESTER) {
        approvalStatus = eventQueueRequesterLabels(event.status)
      } else if (user?.role === Role.ADMIN) {
        approvalStatus = eventQueueAdminLabels(event.status)
      } else if (user?.role === Role.APPROVER) {
        if (user.approverLevel === 1) {
          approvalStatus = eventQueueRequesterLabels(event.status)
        } else {
          approvalStatus = eventQueueAdminLabels(event.status)
        }
      }

      let startTime = liveData?.startTime
        ? moment()
            .startOf('day')
            .add(liveData?.startTime, 'minutes')
            .format('hh:mm A')
        : ''
      let endTime = liveData?.endTime
        ? moment()
            .startOf('day')
            .add(liveData?.endTime, 'minutes')
            .format('hh:mm A')
        : ''

      let dryRunStartTime = event.dryRun?.startTime
        ? moment()
            .startOf('day')
            .add(event.dryRun?.startTime, 'minutes')
            .format('hh:mm A')
        : null

      const dryRun = event.dryRun && event.dryRun.category === 'dry' ? {
        ...event.dryRun,
        dateFormatted: event.dryRun?.date
          ? moment.utc(Number(event.dryRun?.date)).format('MMMM DD, YYYY')
          : null,
        timeFormatted: dryRunStartTime
      } : null

      return {
        ...event,
        approvalStatus,
        date: liveData?.date
          ? moment.utc(Number(liveData?.date)).format('MMMM DD, YYYY')
          : '',
        time:
          startTime && endTime
            ? `${startTime} - ${endTime}`
            : startTime
            ? startTime
            : '',
        dryRun
      }
    })
    return events
  }

  useLayoutEffect(() => {
    const loadEventQueue = async () => {
      const { data } = await getEventQueue()
      let events = data.eventQueue.data.map((x: any) => ({
        ...x,
        roomBooking: x.roomBooking.find((y: any) => y.category === 'live') || null,
        dryRun: x.roomBooking.find((y: any) => y.category === 'dry') || null,
      }))
      events = formatEventQueue(events)
      console.log(events)
      setEventQueue(events)
      if (events.length > 0) setActiveState(events[0].id.toString())
    }

    loadEventQueue()
  }, [])

  const handleCancelEvent = (id: number) => {
    let eventIndex = eventQueue.findIndex(x => x.id === id)
    let events = formatEventQueue([
      ...eventQueue.slice(0, eventIndex),
      {
        ...eventQueue[eventIndex],
        status: EventStatus.SAVED,
        roomBooking: null
      },
      ...eventQueue.slice(eventIndex + 1)
    ])

    setEventQueue(events)
  }

  const handleRevertEvent = (id: number) => {
    let events = eventQueue.filter(x => x.id !== id)
    setEventQueue(events)
    if (events.length > 0) setActiveState(events[0].id.toString())
  }

  return (
    <Grid container sx={{ mb: { sm: '32px' } }} style={flexItemCenter}>
      {/* Top NavBar */}
      <Grid container className={classes.topNavBar}>
        <Grid
          item
          lg={5.6}
          xs={12}
          md={5.6}
          sx={{
            display: 'flex',
            justifyContent: 'space-between',
            pr: { lg: '48px', md: '48px' },
            flexDirection: { lg: 'row', md: 'row' }
          }}
        >
          <Box className={classes.titleContainer}>
            <Box
              sx={{
                width: '64px',
                minWidth: '64px',
                height: '64px',
                borderRadius: '8px',
                mr: '20px',
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                backgroundColor: '#F8F6F2'
              }}
            >
              <Box component='img' src={CalendarIcon} alt='Calendar Icon' />
            </Box>
            <Typography
              sx={{
                maxWidth: { lg: '368px' },
                textAlign: 'left',
                fontSize: { lg: '40px', md: '36px', xs: '32px !important' },
                fontWeight: '600',
                lineHeight: { lg: '48px', md: '43.2px', xs: '38.4px' },
                mt: { sm: '16px' }
              }}
            >
              Welcome to the ETA Event Planner
            </Typography>
          </Box>

          {role !== undefined && !isMobView && (
            <Box style={flexcol}>
              <Typography
                sx={{
                  display: { lg: 'block', md: 'block', xs: 'none' },
                  textAlign: 'left',
                  fontSize: '24px',
                  fontWeight: '600',
                  lineHeight: { lg: '28.8px' },
                  mb: '12px',
                  mt: '8px'
                }}
              >
                Events
              </Typography>
              <IconButton
                sx={{
                  width: '119px',
                  height: '119px',
                  borderRadius: '12px',
                  padding: '8px',
                  border: ' 1px solid rgba(0, 107, 215, 0.2)',
                  boxhadow: '0px 2px 24px rgba(0, 0, 0, 0.08)',
                  display: 'flex',
                  flexDirection: 'column',
                  justifyContent: 'flex-start',
                  alignItems: 'self-start',
                  opacity:
                    user.approvalStatus === ApprovalStatus.APPROVED
                      ? 1
                      : 0.3
                }}
                style={{ backgroundColor: '#FFFFFF' }}
                onClick={navigateRequestingTypePage}
                disabled={user.approvalStatus !== ApprovalStatus.APPROVED}
                size="large">
                <Box
                  sx={{
                    mb: '10px'
                  }}
                  component='img'
                  src={NewEventIcon}
                  alt='NewEventIcon'
                />
                <Typography
                  sx={{
                    fontSize: { lg: '18px' },
                    fontWeight: '500',
                    lineHeight: '22px',
                    textAlign: 'left',
                    color: '#333333'
                  }}
                >
                  Request a new event
                </Typography>
              </IconButton>
            </Box>
          )}
        </Grid>

        {role !== undefined && (
          <CalendarEventSlider
            role={role}
            eventQueue={eventQueue}
            eventsTitle={eventsTitle}
            activeState={activeState}
            setActiveState={setActiveState}
            setOpenAllEvents={setOpenAllEvents}
            handleCancelEvent={handleCancelEvent}
            handleRevertEvent={handleRevertEvent}
          />
        )}
      </Grid>

      <Box
        sx={{ display: 'flex', flexDirection: { lg: 'row', sm: 'column' } }}
      >
        {/* Left NavBar*/}
        <Grid
          item
          xs={12}
          lg={4}
          className={classNames(classes.leftBlock)}
          sx={{
            display: 'flex',
            flexDirection: {
              xs: 'column-reverse',
              sm: 'row-reverse',
              md: 'row-reverse',
              lg: 'column'
            }
          }}
        >
          {/* Accordions */}
          <CalendarAccordions />

          {isMobView && (
            <Grid item sm={12}>
              <Box className={classes.bigCalendarForMobile}>
                <EtaCalendar
                  selectedStatus={selectedStatus}
                  currentDefaultView={Views.AGENDA}
                  userData={userData}
                />
              </Box>
              <Box sx={{ mt: 2 }}>
                <Button
                  startIcon={<AddIcon />}
                  variant='contained'
                  sx={{
                    borderRadius: '63px',
                    fontWeight: 'bold',
                    boxShadow: 'none',
                    pt: 1.25,
                    pb: 1.25
                  }}
                  style={{
                    textTransform: 'none',
                    backgroundColor: '#333333',
                    color: '#ffffff'
                  }}
                  onClick={navigateRequestingTypePage}
                  fullWidth={true}
                >
                  {buttonlabel}
                </Button>
              </Box>
            </Grid>
          )}

          {/* Legend */}
          <CalendarLegend
            role={role}
            approverLevel={approverLevel}
            handleCheckboxChange={handleCheckboxChange}
            flexItemLeft={flexItemLeft}
          />
        </Grid>

        {/* Big Calendra*/}
        {!isMobView && (
          <Grid
            item
            xs={12}
            md={12}
            lg={8}
            sx={
              role === undefined
                ? { marginTop: { lg: '-150px', md: '0' } }
                : {}
            }
          >
            <Box className={classes.bigCalendar}>
              <EtaCalendar
                selectedStatus={selectedStatus}
                currentDefaultView={Views.MONTH}
                userData={userData}
              />
            </Box>
          </Grid>
        )}
      </Box>
      <CalendarDialogs
        openAllEvents={openAllEvents}
        setOpenAllEvents={setOpenAllEvents}
        role={role}
        eventQueue={eventQueue}
        handleCancelEvent={handleCancelEvent}
        handleRevertEvent={handleRevertEvent}
      />
    </Grid>
  );
}
